import {ExpressionElement} from '@packages/systems/wfdl-ast';
import {isSlot} from '@packages/utilities/elementTypeUtils';
import {contains} from '@packages/utilities/platform';

export const selectedElementContainsSlot = (
  selectedElement: ExpressionElement
): boolean => {
  return contains(selectedElement, isSlot);
};
